import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';

const UseRechargeableBatteries = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('My monthly battery use:')}
      </p>
      <ul>
        <li>
          <InlineInput
            maxLength={3}
            apiKey={'input_takeaction_rechargeable_batteries_amount_aaa'}
          />
          {t('AAA')}
        </li>
        <li>
          <InlineInput
            maxLength={3}
            apiKey={'input_takeaction_rechargeable_batteries_amount_aa'}
          />
          {t('AA')}
        </li>
        <li>
          <InlineInput
            maxLength={3}
            apiKey={'input_takeaction_rechargeable_batteries_amount_c'}
          />
          {t('C')}
        </li>
        <li>
          <InlineInput
            maxLength={3}
            apiKey={'input_takeaction_rechargeable_batteries_amount_d'}
          />
          {t('D')}
        </li>
        <li>
          <InlineInput
            maxLength={3}
            apiKey={'input_takeaction_rechargeable_batteries_amount_9v'}
          />
          {t('9V')}
        </li>
      </ul>
      <p>
        {t('I will buy rechargeable batteries instead of disposable ones.')}
      </p>
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' && <a
        href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BEligible+Applicants%253D%253DIndividual%255D%255BCategory%253D%253DEnergy%255D/false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>}
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <p>
        {t('Disposable batteries are alkaline and rechargable batteries are NiCd. Rechargeable batteries can be re-used ')}
        <InlineInput
          maxLength={4}
          apiKey={'input_takeaction_rechargeable_batteries_uses'}
        />
        {t('times and costs')}
        <InlineInput
          maxLength={4}
          apiKey={'input_takeaction_rechargeable_batteries_cost_multiple'}
        />
        {t('times as much as disposable models.')}
      </p>
      <p>{t('Cost of disposable batteries:')}</p>
      <ul>
        <li>
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_rechargeable_batteries_cost_aaa"
          />
          {t('per AAA')}
        </li>
        <li>
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_rechargeable_batteries_cost_aa"
          />
          {t('per AA')}
        </li>
        <li>
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_rechargeable_batteries_cost_c"
          />
          {t('per C')}
        </li>
        <li>
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_rechargeable_batteries_cost_d"
          />
          {t('per D')}
        </li>
        <li>
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_rechargeable_batteries_cost_9v"
          />
          {t('per 9V')}
        </li>
      </ul>
    </div>
  </div>
);

UseRechargeableBatteries.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('rechargeableBatteries'),
  connect(mapStateToProps, mapDispatchToProps)(UseRechargeableBatteries),
);
